import { List } from '@refinedev/antd'
import { IResourceComponentsProps } from '@refinedev/core'
import { Menu, MenuProps } from 'antd'
import { FC, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { CustomerBeneficiariesRemitters } from '../customers/edit/components/customer-beneficiaries-remitters'
import '../styles/index.css'

export const BeneficiariesRemittersList: FC<IResourceComponentsProps> = () => {
  const navigate = useNavigate()
  const [pageType, setPageType] = useState<
    'customers' | 'beneficiaries-remitters'
  >('beneficiaries-remitters')
  
  const FILTER_ITEMS: MenuProps['items'] = [
    {
      label: 'Customer Accounts',
      key: 'customers',
    },
    {
      label: 'Beneficiaries & Remitters',
      key: 'beneficiaries-remitters',
    },
  ]

  const changeFilterPageType = (item: any) => {
    const key = item.key as 'customers' | 'beneficiaries-remitters'
    setPageType(key)
    navigate(`/${key}?pageSize=10&current=1`)
  }

  return (
    <>
      <List title='Beneficiaries & Remitters'>
        <CustomerBeneficiariesRemitters
          isActive={true}
          menu={
            <Menu
              onClick={changeFilterPageType}
              defaultSelectedKeys={[pageType]}
              mode='horizontal'
              items={FILTER_ITEMS}
            />
          }
        />
      </List>
    </>
  )
}
